import { render, staticRenderFns } from "./create-profile.vue?vue&type=template&id=492869be&scoped=true"
import script from "./create-profile.vue?vue&type=script&lang=js"
export * from "./create-profile.vue?vue&type=script&lang=js"
import style0 from "./create-profile.vue?vue&type=style&index=0&id=492869be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492869be",
  null
  
)

export default component.exports